import { render, staticRenderFns } from "./weekly-view-hour-premises.vue?vue&type=template&id=0cce14b7&scoped=true"
import script from "./weekly-view-hour-premises.vue?vue&type=script&lang=js"
export * from "./weekly-view-hour-premises.vue?vue&type=script&lang=js"
import style0 from "./weekly-view-hour-premises.vue?vue&type=style&index=0&id=0cce14b7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cce14b7",
  null
  
)

export default component.exports